import PhoneField from '../PhoneField'

import { OnboardingData } from './types'

interface Step1PersonalInfoProps {
  data: OnboardingData
  currentStep: number
  handleInputChangeWrapper: (field: keyof OnboardingData, value: string | number | null) => void
  setData: React.Dispatch<React.SetStateAction<OnboardingData>>
}

export function Step1PersonalInfo({
  data,
  currentStep,
  handleInputChangeWrapper,
  setData,
}: Step1PersonalInfoProps) {
  return (
    <div className={currentStep === 1 ? "space-y-4" : "hidden"}>
      <div>
        <label htmlFor="firstName" className="block text-sm font-medium text-text-secondary">
          First Name *
        </label>
        <input
          id="firstName"
          name="firstName"
          type="text"
          autoComplete="given-name"
          required={currentStep === 1}
          value={data.firstName}
          onChange={(e) => handleInputChangeWrapper('firstName', e.target.value)}
          onInput={(e) => {
            // Handle browser autofill - Chrome might fill this with full name
            const value = (e.target as HTMLInputElement).value
            if (value.includes(' ') && value.split(' ').length > 1) {
              const parts = value.split(' ')
              const firstName = parts[0]
              const lastName = parts.slice(1).join(' ')
              if (firstName && lastName && !data.lastName) {
                setData(prev => ({
                  ...prev,
                  firstName: firstName,
                  lastName: lastName,
                }))
              }
            } else {
              handleInputChangeWrapper('firstName', value)
            }
          }}
          onFocus={(e) => {
            // Force browser to recognize field for autocomplete
            e.target.setAttribute('autocomplete', 'given-name')
          }}
          className="mt-1 block w-full px-3 py-2 border border-border-default rounded-md shadow-sm focus:outline-none focus:ring-interactive-focus-ring focus:border-interactive"
        />
      </div>

      <div>
        <label htmlFor="lastName" className="block text-sm font-medium text-text-secondary">
          Last Name *
        </label>
        <input
          id="lastName"
          name="lastName"
          type="text"
          autoComplete="family-name"
          required={currentStep === 1}
          value={data.lastName}
          onChange={(e) => handleInputChangeWrapper('lastName', e.target.value)}
          onFocus={(e) => {
            e.target.setAttribute('autocomplete', 'family-name')
          }}
          className="mt-1 block w-full px-3 py-2 border border-border-default rounded-md shadow-sm focus:outline-none focus:ring-interactive-focus-ring focus:border-interactive"
        />
        {data.firstName && data.lastName && data.firstName === data.lastName && data.firstName.trim() !== '' && (
          <p className="mt-1 text-sm text-amber-600">
            ⚠️ Похоже, что имя и фамилия совпадают. Пожалуйста, проверьте и исправьте фамилию вручную.
          </p>
        )}
      </div>

      <div>
        <label htmlFor="phone" className="block text-sm font-medium text-text-secondary mb-1">
          Phone
        </label>
        <div className="mt-1">
          <PhoneField
            id="phone"
            name="phone"
            value={data.phone || null}
            onChange={(value) => handleInputChangeWrapper('phone', value || '')}
          />
        </div>
      </div>

      <div>
        <label htmlFor="email" className="block text-sm font-medium text-text-secondary">
          Email *
        </label>
        <input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required={currentStep === 1}
          value={data.email}
          onChange={(e) => handleInputChangeWrapper('email', e.target.value)}
          onFocus={(e) => {
            e.target.setAttribute('autocomplete', 'email')
          }}
          className="mt-1 block w-full px-3 py-2 border border-border-default rounded-md shadow-sm focus:outline-none focus:ring-interactive-focus-ring focus:border-interactive"
        />
      </div>
    </div>
  )
}
